import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  GetAllPersonsFromGroupUseCaseInterface,
  GetAllPlacesFromGroupUseCaseInterface,
  GetGroupByIdUseCaseInterface,
} from 'domain/usecases';

interface IGroupSettigsState {
  selectedGroupData: GetGroupByIdUseCaseInterface.Result;
  selectedGroupCoordinatorsListData: GetAllPersonsFromGroupUseCaseInterface.Result;
  selectedGroupTeachersListData: GetAllPersonsFromGroupUseCaseInterface.Result;
  selectedGroupPreceptorsListData: GetAllPersonsFromGroupUseCaseInterface.Result;
  selectedGroupStudentsListData: GetAllPersonsFromGroupUseCaseInterface.Result;
  selectedGroupInternshipLocationsListData: any;
}

interface IPayloadSelectedGroupData
  extends PayloadAction<GetGroupByIdUseCaseInterface.Result> {}

interface IPayloadSelectedGroupCoordinatorsListData
  extends PayloadAction<GetAllPersonsFromGroupUseCaseInterface.Result> {}

interface IPayloadSelectedGroupTeachersListData
  extends PayloadAction<GetAllPersonsFromGroupUseCaseInterface.Result> {}

interface IPayloadSelectedGroupPreceptorsListData
  extends PayloadAction<GetAllPersonsFromGroupUseCaseInterface.Result> {}

interface IPayloadSelectedGroupStudentsListData
  extends PayloadAction<GetAllPersonsFromGroupUseCaseInterface.Result> {}

interface IPayloadSelectedGroupInternshipLocationsListData
  extends PayloadAction<GetAllPlacesFromGroupUseCaseInterface.Result> {}

const initialState: IGroupSettigsState = {
  selectedGroupData: null,
  selectedGroupCoordinatorsListData: [],
  selectedGroupTeachersListData: [],
  selectedGroupPreceptorsListData: [],
  selectedGroupStudentsListData: [],
  selectedGroupInternshipLocationsListData: [],
};

export const GroupSettingsSlice = createSlice({
  name: 'groups',
  initialState,
  reducers: {
    loadSelectedGroupData: (state, action: IPayloadSelectedGroupData) => {
      state.selectedGroupData = action.payload;
    },
    clearSelectedGroupData: (state) => {
      state.selectedGroupData = null;
    },
    loadSelectedGroupCoordinatorsListData: (
      state,
      action: IPayloadSelectedGroupCoordinatorsListData,
    ) => {
      state.selectedGroupCoordinatorsListData = action.payload;
    },
    clearSelectedGroupCoordinatorsListData: (state) => {
      state.selectedGroupCoordinatorsListData = [];
    },
    loadSelectedGroupTeachersListData: (
      state,
      action: IPayloadSelectedGroupTeachersListData,
    ) => {
      state.selectedGroupTeachersListData = action.payload;
    },
    clearSelectedGroupTeachersListData: (state) => {
      state.selectedGroupTeachersListData = [];
    },
    loadSelectedGroupPreceptorsListData: (
      state,
      action: IPayloadSelectedGroupPreceptorsListData,
    ) => {
      state.selectedGroupPreceptorsListData = action.payload;
    },
    clearSelectedGroupPreceptorsListData: (state) => {
      state.selectedGroupPreceptorsListData = [];
    },
    loadSelectedGroupStudentsListData: (
      state,
      action: IPayloadSelectedGroupStudentsListData,
    ) => {
      state.selectedGroupStudentsListData = action.payload;
    },
    clearSelectedGroupStudentsListData: (state) => {
      state.selectedGroupStudentsListData = [];
    },
    loadSelectedGroupInternshipLocationsListData: (
      state,
      action: IPayloadSelectedGroupInternshipLocationsListData,
    ) => {
      state.selectedGroupInternshipLocationsListData = action.payload;
    },
    clearSelectedGroupInternshipLocationsListData: (state) => {
      state.selectedGroupInternshipLocationsListData = [];
    },
  },
});

export const {
  loadSelectedGroupData,
  clearSelectedGroupData,
  loadSelectedGroupCoordinatorsListData,
  clearSelectedGroupCoordinatorsListData,
  loadSelectedGroupTeachersListData,
  clearSelectedGroupTeachersListData,
  loadSelectedGroupPreceptorsListData,
  clearSelectedGroupPreceptorsListData,
  loadSelectedGroupStudentsListData,
  clearSelectedGroupStudentsListData,
  loadSelectedGroupInternshipLocationsListData,
  clearSelectedGroupInternshipLocationsListData,
} = GroupSettingsSlice.actions;

export default GroupSettingsSlice.reducer;
